export class TwcaFormWindowLib {
  constructor() {
  }

  #createForm(target, url, inputFields) {
    let form = document.createElement('form');
    form.target = target;
    form.method = 'post';
    form.action = url;

    inputFields.forEach(field => {
      let inputElement = document.createElement('input');
      inputElement.type = 'hidden';
      inputElement.name = field.name;
      inputElement["val" + "ue"] = field["val" + "ue"];
      form.appendChild(inputElement);
    });

    document.body.appendChild(form);
    return form;
  }

  #openWindow(url, target, formData, options = {}) {
    const defaultOptions = {
      width: 1000,
      height: 600,
      target: target
    };
    const opts = { ...defaultOptions, ...options };

    const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
    const width = window.innerWidth || document.documentElement.clientWidth || screen.width;
    const height = window.innerHeight || document.documentElement.clientHeight || screen.height;
    const left = ((width / 2) - (opts.width / 2)) + dualScreenLeft;
    const top = ((height / 2) - (opts.height / 2)) + dualScreenTop;

    const form = this.#createForm(opts.target, url, formData);

    if (!['_self', '_parent', '_top', '_blank'].includes(opts.target)) {
      const newWindow = window.open('', opts.target, `width=${opts.width},height=${opts.height},left=${left},top=${top}`);

      if (newWindow) {
        form.submit();
        newWindow.focus();
      }
    } else {
      form.submit();
    }
  }

  openFiscAccAgtWindow(url, postData, options = {}) {
    const formData = [
      { name: 'IBPD_Param', value: postData }
    ];
    this.#openWindow(url, 'newFiscAccAgtWindow', formData, options);
  }

  openMegaAccAgtWindow(url, postData, options = {}) {
    const postJson = JSON.parse(postData);
    const formData = [
      { name: 'channelID', value: postJson.channelID },
      { name: 'MsgType', value: postJson.MsgType },
      { name: 'tFdId', value: postJson.tFdId },
      { name: 'TxType', value: postJson.TxType },
      { name: 'UserID', value: postJson.UserID },
      { name: 'PhoneNo', value: postJson.PhoneNo },
      { name: 'BankID', value: postJson.BankID },
      { name: 'AcctID', value: postJson.AcctID },
      { name: 'PayActNo', value: postJson.PayActNo },
      { name: 'TxnSeq', value: postJson.TxnSeq },
      { name: 'EntrustUnit', value: postJson.EntrustUnit },
      { name: 'FeeType', value: postJson.FeeType },
      { name: 'FeeNo', value: postJson.FeeNo },
      { name: 'checkSum', value: postJson.checkSum }
    ];
    this.#openWindow(url, 'newMegaAccAgtWindow', formData, options);
  }

  openTdccAccAgtWindow(url, postData, options = {}) {
    const postJson = JSON.parse(postData);
    const formData = [
      { name: 'ApplyDate', value: postJson.ApplyDate },
      { name: 'SeqNo', value: postJson.SeqNo },
      { name: 'InvestorCode', value: postJson.InvestorCode },
      { name: 'InvestorID', value: postJson.InvestorID },
      { name: 'BankID', value: postJson.BankID },
      { name: 'BankAcct', value: postJson.BankAcct },
      { name: 'AcctKind', value: postJson.AcctKind },
      { name: 'ApplyType', value: postJson.ApplyType },
      { name: 'RedirectURL', value: postJson.RedirectURL },
      { name: 'CheckSum', value: postJson.CheckSum }
    ];
    this.#openWindow(url, 'newTdccAccAgtWindow', formData, options);
  }

  openAlsVerifyWindow(url, eddarbank, rbanktoken, options = {}) {
    const formData = [
      { name: 'eddarbank', value: eddarbank },
      { name: 'rbanktoken', value: rbanktoken }
    ];
    this.#openWindow(url, 'newWindowForBankAccountLogin', formData, options);
  }
}
